import config from '../config';

const getCountries = async () => {
  const response = await fetch(`${config.API_URL}/countries`);
  return response.json();
};

const countryService = {
  getCountries
};

export default countryService;